import { useEffect } from 'react'
import { amplTrack } from '@stlm/common-ui/lib'
import { EventDetails } from '../EventDetails/EventDetails'
import { useAppSelector } from '../../../../../../hooks/redux/redux'
import { useSideBarControlls } from '../../../../../../hooks/useSideBarControlls'
import { ExtendedEvent } from '../../../../../../constants/types'

type EventInfoProps = { event: ExtendedEvent }

export const EventInfo = ({ event }: EventInfoProps) => {
  const { isSideBarCloseInitiated } = useAppSelector((state) => state.app)
  const { closeSideBar } = useSideBarControlls()

  useEffect(() => {
    if (isSideBarCloseInitiated) closeSideBar()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSideBarCloseInitiated])

  useEffect(() => {
    amplTrack({ name: 'map_event_details_view' })
  }, [])

  return <EventDetails event={event} />
}
